import React from 'react';
import { Clock, AlertCircle, Truck, Receipt, PauseCircle, Ban } from 'lucide-react';
import { ORDER_STATUS, ORDER_STATUS_LABELS, ORDER_STATUS_COLORS } from '../../utils/constants';

// Icônes par statut
const STATUS_ICONS = {
    [ORDER_STATUS.PENDING]: Clock,
    [ORDER_STATUS.IN_PROGRESS]: AlertCircle,
    [ORDER_STATUS.SHIPPED]: Truck,
    [ORDER_STATUS.INVOICED]: Receipt,
    [ORDER_STATUS.PAUSED]: PauseCircle,
    [ORDER_STATUS.CANCELLED]: Ban
};

const StatusBadge = ({ status }) => {
    const label = ORDER_STATUS_LABELS[status] || 'Inconnu';
    const colorClass = ORDER_STATUS_COLORS[status] || 'bg-gray-500/20 text-gray-400 border-white/20';
    const IconComponent = STATUS_ICONS[status] || Clock;

    return (
        <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium border ${colorClass}`}>
            <IconComponent className="w-3 h-3 mr-1.5" />
            {label}
        </span>
    );
};

export default StatusBadge;
